import React, { useState } from "react";
import { Icon, IconButton } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import ArtApi from "../api/ArtApi";

interface IDownloadMsgPackProps {
    eventId: string
}

export const DownloadMsgPack = (props: IDownloadMsgPackProps) => {
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);


    const handleDownload = () => {
        setIsLoading(true);
        ArtApi.getMsgpackFile(props.eventId)
            .then(result => {
                setIsLoading(false);
                setIsSuccess(true);
                const file = new Blob([result], {
                    type: "application/octet-stream"
                });
                //Build a URL from the file
                const fileURL = URL.createObjectURL(file);
                //Open the URL on new Window
                //window.open(fileURL);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;

                // it forces the name of the downloaded file
                fileLink.download = props.eventId + ".bin";

                // triggers the click event
                fileLink.click();
            }).catch(error => {
                setIsLoading(false);
                setSnackbarOpen(true);
                setError(error.message);
            })
    };

    return (
        <div>
            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
            >
                <SnackbarContent
                    className="errorSnackbar"
                    message={
                        <span id="message-id" className="snackbarMessage">
                            <Icon className="snackbarIcon">error</Icon>
                            Error Occured: {error}
                        </span>
                    }
                    action={[
                        <IconButton
                            key="close"
                            aria-label="close"
                            color="inherit"
                            onClick={() => setSnackbarOpen(false)}
                        >
                            <Icon>close</Icon>
                        </IconButton>
                    ]}
                />
            </Snackbar>


            {isLoading ?
                <CircularProgress size={24} /> :
                <IconButton
                    key="cloud_download"
                    aria-label="cloud_download"
                    color="inherit"
                    onClick={() => handleDownload()}
                >
                    <Icon>{isSuccess ? "download_done" : "cloud_download"}</Icon>
                </IconButton>
            }
        </div>
    );
}



